module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"description":"Descrição","offered-by":"Oferecido por","price":"Preço (R$)"}}')
  delete Component.options._Ctor
}
